module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/not-found/not-found.component.scss
// module id = ./src/app/shared/components/not-found/not-found.component.scss
// module chunks = main